export default {
    //接口地址
    // baseURL:'http://192.168.20.230:8010/api/v1',
    baseURL:'https://cloud.jjr.vip/api/v1',

    //图片地址
    // imgURL:'http://192.168.20.230:8010/storage/',
    imgURL:'https://cloud.jjr.vip/storage/',

    //websocket地址
    websocketURL:'wss://websocket.jjr.vip/wss',
}